import React from 'react';
import PropTypes from 'prop-types';

/** An inline svg component. */
const JCB = ({
  size = 16,
  height = 20,
  width = 26,
  svgRef,
  title,
  style = {},
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 26 20"
      height={height || size}
      width={width || size}
      ref={svgRef}
      aria-labelledby={title ? title : undefined}
      style={{ pointerEvents: 'none', ...style }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      {title ? <title id={title}>{title}</title> : null}

      <g id="JCB" clip-path="url(#clip0_677_16923)">
        <path
          id="Vector"
          d="M25.9574 15.9621C25.9574 18.1919 24.1496 20.0008 21.9194 20.0008H0V4.03875C0 1.80812 1.80782 0 4.0381 0H25.9574V15.9621Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M18.8105 11.8721H20.48C20.5321 11.8721 20.6314 11.864 20.6794 11.8534C21.0001 11.7842 21.2671 11.4993 21.2671 11.1118C21.2671 10.7243 21.0001 10.4385 20.6794 10.3693C20.6322 10.3587 20.5329 10.3506 20.48 10.3506H18.8105V11.8721Z"
          fill="url(#paint0_linear_677_16923)"
        />
        <path
          id="Vector_3"
          d="M20.2853 1.34656C18.6923 1.34656 17.4014 2.63772 17.4014 4.23091V7.2268H21.4826C21.577 7.2268 21.6926 7.23332 21.7651 7.23739C22.6889 7.28379 23.3694 7.75841 23.3694 8.58147C23.3694 9.22868 22.9038 9.78226 22.0565 9.90682V9.93939C22.9925 10.0045 23.7088 10.519 23.7088 11.3315C23.7088 12.2099 22.9225 12.7741 21.8741 12.7741H17.4014V18.6543H21.6316C23.2245 18.6543 24.5154 17.3624 24.5154 15.77V1.34656H20.2853Z"
          fill="url(#paint1_linear_677_16923)"
        />
        <path
          id="Vector_4"
          d="M21.0685 8.78985C21.0685 8.40885 20.8015 8.15322 20.4881 8.10031C20.4588 8.09542 20.3791 8.08728 20.3237 8.08728H18.8105V9.4916H20.3237C20.3791 9.4916 20.4588 9.48346 20.4881 9.47858C20.8023 9.42566 21.0685 9.17003 21.0685 8.78903V8.78985Z"
          fill="url(#paint2_linear_677_16923)"
        />
        <path
          id="Vector_5"
          d="M4.32611 1.34656C2.73317 1.34656 1.44222 2.63772 1.44222 4.23091V11.3543C2.2513 11.7459 3.08644 12.0015 3.93703 12.0015C4.93414 12.0015 5.48194 11.3926 5.48194 10.5736V7.2268H7.96211V10.5736C7.96211 11.8826 7.15872 12.9328 4.40181 12.9328C2.74294 12.9328 1.44141 12.5746 1.44141 12.5746V18.6535H5.6716C7.26453 18.6535 8.55549 17.3615 8.55549 15.7692V1.34656H4.3253H4.32611Z"
          fill="url(#paint3_linear_677_16923)"
        />
        <path
          id="Vector_6"
          d="M12.3058 1.34656C10.7128 1.34656 9.42188 2.63772 9.42188 4.23091V8.00753C10.1528 7.38067 11.4161 6.98909 13.4697 7.08108C14.5686 7.12993 15.7342 7.42463 15.7342 7.42463V8.64578C15.1506 8.35026 14.4514 8.07591 13.5503 8.00834C11.9924 7.8903 11.0547 8.65229 11.0547 10.0004C11.0547 11.3486 11.9924 12.1098 13.5503 11.9917C14.4514 11.9242 15.1604 11.6425 15.7342 11.3551V12.5754C15.7342 12.5754 14.5686 12.8701 13.4697 12.9198C11.4169 13.0118 10.1528 12.6202 9.42188 11.9934V18.6543H13.6521C15.245 18.6543 16.536 17.3624 16.536 15.77V1.34656H12.3058Z"
          fill="url(#paint4_linear_677_16923)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_677_16923"
          x1="17.3161"
          y1="11.0567"
          x2="24.4169"
          y2="11.0567"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007F49" />
          <stop offset="0.29" stop-color="#1F9248" />
          <stop offset="0.76" stop-color="#4FAF46" />
          <stop offset="1" stop-color="#62BB46" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_677_16923"
          x1="17.3167"
          y1="9.94971"
          x2="24.4175"
          y2="9.94971"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007F49" />
          <stop offset="0.29" stop-color="#1F9248" />
          <stop offset="0.76" stop-color="#4FAF46" />
          <stop offset="1" stop-color="#62BB46" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_677_16923"
          x1="17.3161"
          y1="8.7452"
          x2="24.4169"
          y2="8.7452"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007F49" />
          <stop offset="0.29" stop-color="#1F9248" />
          <stop offset="0.76" stop-color="#4FAF46" />
          <stop offset="1" stop-color="#62BB46" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_677_16923"
          x1="1.41901"
          y1="9.94971"
          x2="8.63011"
          y2="9.94971"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#333376" />
          <stop offset="0.09" stop-color="#2D3A7D" />
          <stop offset="0.7" stop-color="#0C66AD" />
          <stop offset="1" stop-color="#0077C0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_677_16923"
          x1="9.33058"
          y1="9.94971"
          x2="16.3338"
          y2="9.94971"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#743237" />
          <stop offset="0.4" stop-color="#AA263D" />
          <stop offset="0.8" stop-color="#DA1B43" />
          <stop offset="1" stop-color="#ED1846" />
        </linearGradient>
        <clipPath id="clip0_677_16923">
          <rect width="25.9574" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

JCB.propTypes = {
  /** Optional class name to apply to `svg` element. */
  className: PropTypes.string,
  /** Height of `svg`. */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Gets applied to both `height` and `width` of `svg`. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Use if you want to get a `ref` to the `svg` element. */
  svgRef: PropTypes.func,
  /** For accessability. Allows icons in buttons etc. to be read by screen readers. */
  title: PropTypes.string,
  /** Width of `svg`. */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export { JCB };
